/**
 * The one booking calendar.
 *
 * "Book a Demo" and "Talk to the concierge" send people to the same place, so
 * the URL lives here instead of being copied into each modal and drifting
 * apart. Override with VITE_DEMO_BOOKING_URL without touching code.
 *
 * Google's booking page sends X-Frame-Options: SAMEORIGIN — verified,
 * including with ?gv=true — so it cannot be embedded and has to open in a new
 * tab.
 */
export const CONCIERGE_BOOKING_URL =
  (import.meta as any).env?.VITE_DEMO_BOOKING_URL
  || 'https://calendar.app.google/HtDTkJ2ScJTVcJZ76';

/**
 * The public homepage's "Book a Demo" goes somewhere else — a separate
 * calendar, asked for on 2026-09-11. Kept as its own constant rather than
 * repointing CONCIERGE_BOOKING_URL, because that one is also what "Talk to the
 * concierge" and the in-app pricing modal use, and moving those was not asked
 * for. Override with VITE_HOMEPAGE_DEMO_URL.
 */
export const HOMEPAGE_DEMO_BOOKING_URL =
  (import.meta as any).env?.VITE_HOMEPAGE_DEMO_URL
  || 'https://calendar.app.google/RgmRVVC6dZUBBPbf9';

/** Which CTA the person pressed. Kept in step with SOURCES in
 *  Backend/interest_service.py — the server rejects anything else rather
 *  than silently creating a bucket nobody looks at. */
export type InterestSource = 'book_demo' | 'book_call' | 'concierge';
